import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {httpDeleteProjectSuspension} from '@/features/projects/http/projects.http'

export const useDeleteProjectSuspension = (
    projectId: string,
    suspensionId: string,
    options?: Omit<UseMutationOptions, 'mutationFn'>
) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.DELETE_PROJECT_SUSPENSION],
        mutationFn: () => httpDeleteProjectSuspension({urlParams: {projectId, suspensionId}}),
        ...options
    })
